import clsx from 'clsx'
import type { FC } from 'react'

import type { SectionProps } from '@/types/components/section'
import './section.scss'

export const Section: FC<SectionProps> = ({
  id,
  hasWrapper = true,
  size = 'default',
  theme,
  children,
}) => {
  const classes = [
    'section',
    { [`theme-${theme}`]: theme },
    { [`section--py-${size}`]: size !== 'default' },
  ]

  const wrapperClasses = ['section__wrapper', { wrapper: hasWrapper }]

  return (
    <section id={id} className={clsx(classes)}>
      <div className={clsx(wrapperClasses)}>{children}</div>
    </section>
  )
}
